// Add your custom JS here.

(function ($) {
    $('.slider-home').slick({
        dots: true,
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        arrows: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                arrows: false
            }
    }]
    });
    $('.slide-galeria').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: true
    });

    $('.slider-depoimentos').slick({
        dots: true,
        autoplay: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 1,
        arrows: false
    });

    $(document).on('click', '.js-videoPoster', function (e) {

        //отменяем стандартное действие button
        e.preventDefault();
        var poster = $('.video-wrapper');
        // ищем родителя ближайшего по классу
        var wrapper = poster.closest('.js-videoWrapper');
        videoPlay(wrapper);
    });

    //вопроизводим видео, при этом скрывая постер
    function videoPlay(wrapper) {
        var iframe = wrapper.find('.js-videoIframe');
        // Берем ссылку видео из data
        var src = iframe.data('src');
        // скрываем постер
        $('.video-banner-wrapper').addClass('videoWrapperActive');
        // подставляем в src параметр из data
        iframe.attr('src', src);
    }

})(jQuery);